const prefix = "PRISMS_USER_";

export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";

export const ENABLE_MFA = prefix + "ENABLE_MFA";
export const DISABLE_MFA = prefix + "DISABLE_MFA";
export const SWITCH_TO_EMAIL_MFA = prefix + "SWITCH_TO_EMAIL_MFA";

export const VIEW_MFA_PROFILE = prefix + "VIEW_MFA_PROFILE";
export const EXPORT = prefix + "EXPORT";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
export const SETUP_AUTHENTICATOR_APP_MFA = prefix + "SETUP_AUTHENTICATOR_APP_MFA";
export const SETUP_AUTHENTICATOR_APP_MFA_GET = prefix + "SETUP_AUTHENTICATOR_APP_MFA_GET";
export const SETUP_EMAIL_MFA = prefix + "SETUP_EMAIL_MFA";
